module.exports = __webpack_public_path__ + "static/media/splash.b46011c8.png";